import React from "react";
import PartnerSection from "@modules/study/common/sections/partner/partner";
import UniPageBookingSection from "@modules/study/unipages/section_booking";

import {
  UniPageQualityHero,
  UniPageQualityProspects,
  UniPageQualityEnsure,
  UniPageQualityDiversify,
  UniPageQualityGetResult,
} from "@modules/study/unipages/quality";
import { LayoutUniversityPage } from "@unisearch/theme/layout";

const QualityControl = () => {
  return (
    <LayoutUniversityPage
      title="International Student Recruitment Strategy | UniSearch for University Quality Control"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/university/quality-control`}
    >
      <UniPageQualityHero />
      <PartnerSection />
      <UniPageQualityProspects />
      <UniPageQualityEnsure />
      <UniPageQualityDiversify />
      <UniPageQualityGetResult />
      <UniPageBookingSection />
    </LayoutUniversityPage>
  );
};

export default QualityControl;
